import { writable } from "svelte/store";
import persisted from "./common/persisted";

const POINT_INTERVAL = 5;

function createStore() {
    const { subscribe, update, set } = writable({
        routes: []
    });

    return {
        subscribe,
        set,
        add(route) {
            const path = route
                .filter((_0, i) => i % POINT_INTERVAL === 0)
                .concat(route.at(-1));

            update((state) => ({ ...state, routes: [...state.routes, path] }));
        }
    };
}

const store = persisted("history:v1", true, createStore());

export default store;
